export { default } from './TwoColumnsText';
export { default as adapter } from './adapter';
